import { Device, until } from '@helpers/media';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { useMedia } from 'react-use';
import PaginationStyles from './Pagination.styles';
const Pagination = ({ pageIndex, pageSize, totalCount, onPageChange, }) => {
    const isMobile = useMedia(until(Device.Tablet), false);
    return (React.createElement(PaginationStyles.Wrapper, null,
        React.createElement(ReactPaginate, { pageCount: Math.ceil(totalCount / pageSize), pageRangeDisplayed: isMobile ? 1 : 3, marginPagesDisplayed: 1, previousLabel: getSvgFromSystem(SystemIcon.ChevronLeft), nextLabel: getSvgFromSystem(SystemIcon.ChevronRight), forcePage: pageIndex - 1, hrefBuilder: (page, pageCount) => page >= 1 && page <= pageCount ? `?pageIndex=${page}` : '#', hrefAllControls: true, onPageChange: ({ selected }) => {
                onPageChange(selected + 1);
            } })));
};
export default Pagination;
